if (typeof DynaCore_FormConfig_Row == 'undefined') {
    var DynaCore_FormConfig_Row =
    {
        partClass: 'el-row',
        partName: 'row',
        partSelector: '.el-row',

        /**
         * Inicializace objektu typu Row
         */
        init: function () {
            DynaCore_FormConfig_Row.contextMenuInit();
            DynaCore_FormConfig_Row.dragDropInit();
            DynaCore_FormConfig_Row.sortableInit();
        },

        contextMenuInit: function () {
            $('#designer')
                .off('contextmenu', DynaCore_FormConfig_Row.partSelector)
                .on('contextmenu', DynaCore_FormConfig_Row.partSelector, function (e) {
                    DynaCore_FormConfig_Row.contextMenuShow(e, this);
                    return false;
                });
        },

        /**
         * Inicializace kontextoveho menu objektu typu Row
         *
         * @param e
         * @param element
         */
        contextMenuShow: function (e, element) {
            DynaBase_ContextMenu.addHeader(translate('Row'));

            // Vlastnosti
            DynaBase_ContextMenu.addButton(translate('Properties'), 'toggle-on', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Properties.edit(element, DynaCore_FormConfig_Row.partName + 's', storageId);
            });

            // Tlacitko - Nastaveni
            DynaBase_ContextMenu.addButton(translate('Settings'), 'cog', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Settings.edit(element, DynaCore_FormConfig_Row.partName + 's', storageId);
            });

            // Tlacitko - Odstranit
            DynaBase_ContextMenu.addButton(translate('Remove'), 'trash', function () {
                DynaCore_FormConfig_Row.delete(element);
            });

            // Sestaveni
            DynaBase_ContextMenu.build(e, element);
        },

        /**
         * Inicializace pretahovani objektu typu Row
         */
        dragDropInit: function () {
            // Vkladani radku
            $('#designer, #designer .tab-pane').droppable({
                accept: '[data-type="row"]',
                addClasses: false,
                greedy: true,
                over: function () {
                    var hasClass = $(this).hasClass('tab-pane');
                    var isInsideTab = $(this).parents('.tab-pane').hasClass('tab-pane');

                    if (true == hasClass) {
                        $(this).addClass('over');
                        $('#designer').removeClass('over');
                    }

                    if (true == isInsideTab) {
                        $(this).parents('.tab-pane').addClass('over');
                        $('#designer').removeClass('over');
                    }

                    if (false == hasClass && false == isInsideTab) {
                        $('#designer').addClass('over');
                    }
                },
                out: function () {
                    var hasClass = $(this).hasClass('tab-pane');
                    var isRow = $(this).hasClass(DynaCore_FormConfig_Row.partClass);

                    if (true == isRow) {
                        $(this).removeClass('over');
                    }

                    if (true == hasClass) {
                        $('#designer').addClass('over');
                        $(this).removeClass('over');
                    }
                },
                drop: function (event, ui) {
                    $(this).removeClass('over');

                    var hasClass = $(this).hasClass('tab-pane');
                    var element = this;

                    if (false == hasClass) {
                        element = $(this).parents('.tab-pane');

                        $(element).removeClass('over');
                    }

                    DynaCore_FormConfig_Row.add(ui.draggable, this);
                }
            });

            // Vkladani sloupcu
            $('#designer').find(DynaCore_FormConfig_Row.partSelector).droppable({
                accept: '[data-type="col"], [data-type="row"]',
                addClasses: false,
                greedy: true,
                over: function (event, ui) {
                    var type = $(ui.draggable).data('type');
                    var isInsideTab = $(this).parents('.tab-pane').hasClass('tab-pane');

                    if ('col' == type) {
                        var isRow = $(this).hasClass(DynaCore_FormConfig_Row.partClass);

                        if (true === isRow) {
                            $(this).addClass('over');
                        } else {
                            $(this).parent().addClass('over');
                        }

                        if (true == isInsideTab) {
                            $(this).parents('.tab-pane').parents(DynaCore_FormConfig_Row.partSelector).removeClass('over');
                        }
                    } else {
                        if (true == isInsideTab) {
                            $(this).parent().addClass('over');
                            $('#designer').removeClass('over');
                        }
                    }
                },
                out: function (event, ui) {
                    var type = $(ui.draggable).data('type');
                    var isInsideTab = $(this).parents('.tab-pane').hasClass('tab-pane');

                    if ('col' == type) {
                        var isRow = $(this).hasClass(DynaCore_FormConfig_Row.partClass);

                        if (true === isRow) {
                            $(this).removeClass('over');
                        } else {
                            $(this).parent().removeClass('over');
                        }

                        if (true == isInsideTab) {
                            $(this).parents('.tab-pane').parents(DynaCore_FormConfig_Row.partSelector).addClass('over');
                        }
                    } else {
                        if (true == isInsideTab) {
                            $(this).parent().removeClass('over');
                        }
                    }
                },
                drop: function (event, ui) {
                    var type = $(ui.draggable).data('type');
                    var isInsideTab = $(this).parents('.tab-pane').hasClass('tab-pane');
                    var el = this;

                    if ('col' == type) {
                        var isRow = $(this).hasClass(DynaCore_FormConfig_Row.partClass);

                        if (true === isRow) {
                            $(this).removeClass('over');
                            //el = this;
                        } else {
                            el = $(this).parent();
                            $(this).parent().removeClass('over');
                        }

                        if (true == isInsideTab) {
                            $(this).parents('.tab-pane').parents(DynaCore_FormConfig_Row.partSelector).removeClass('over');
                        }
                    } else {
                        $(this).parent().removeClass('over');
                        el = $(this).parent();

                        DynaCore_FormConfig_Row.add(ui.draggable, el);

                        return false;
                    }

                    DynaCore_FormConfig_Col.add(ui.draggable, el);
                }
            });
        },

        /**
         * Inicializace razeni objektu typu Row
         */
        sortableInit: function () {
            var indexStructureOld = 0;
            var indexStructureNew = 0;

            $("#designer").sortable({
                axis: 'y',
                forcePlaceholderSize: true,
                forceHelperSize: true,
                items: DynaCore_FormConfig_Row.partSelector,
                start: function (e, ui) {
                    $(e.target).children(DynaCore_FormConfig_Row.partSelector).each(function (i, el) {
                        if ($(el).is(ui.item)) {
                            indexStructureOld = i;
                        }
                    });
                },
                update: function (e, ui) {
                    $(e.target).children(DynaCore_FormConfig_Row.partSelector).each(function (i, el) {
                        if ($(el).is(ui.item)) {
                            indexStructureNew = i;
                        }
                    });

                    var data = {};
                    if (parseInt($(ui.item).data('tab')) >= 0) {
                        data = {
                            _ch: $('#_ch').val(),
                            r: $(ui.item).data('row'),
                            c: $(ui.item).data('col'),
                            t: $(ui.item).data('tab'),
                            o: indexStructureOld,
                            n: indexStructureNew
                        };
                    } else {
                        data = {
                            _ch: $('#_ch').val(),
                            o: indexStructureOld,
                            n: indexStructureNew
                        };
                    }

                    $.ajax({
                        type: 'get',
                        url: window.location.href.replace('/form-config/', '/form-config/row-sort/'),
                        data: data,
                        dataType: "json",
                        success: function () {
                            DynaCore_FormConfig.reindex();
                        }
                    });
                }
            });
        },

        /**
         * Pridani objektu typu Row
         *
         * @param element
         * @param elementParent
         * @returns {boolean}
         */
        add: function (element, elementParent) {
            var data = {};
            var indexRow;
            var indexCol;
            var indexTab;
            var indexTabRow;
            var indexTabCol;

            if ($(elementParent).hasClass('tab-pane')) {
                indexRow = $(elementParent).data('row');
                indexCol = $(elementParent).data('col');
                indexTab = $(elementParent).data('tab');
                indexTabRow = $(elementParent).children(DynaCore_FormConfig_Row.partSelector).length;
                indexTabCol = 0;
                data = {
                    _ch: $('#_ch').val(),
                    r: indexRow,
                    c: indexCol,
                    t: indexTab,
                    tr: indexTabRow,
                    paIn: indexTabRow
                };
            } else {
                indexRow = $(elementParent).children(DynaCore_FormConfig_Row.partSelector).length;
                indexCol = 0;
                data = {
                    _ch: $('#_ch').val(),
                    r: indexRow,
                    paIn: indexRow
                };
            }

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/form-config/', '/form-config/row-add/'),
                data: data,
                dataType: "json",
                success: function () {
                    var html = '';

                    if ($(elementParent).hasClass('tab-pane')) {
                        html += '<div class="row el ' + DynaCore_FormConfig_Row.partClass + '" data-row="' + indexRow + '"  data-col="' + indexCol + '"  data-tab="' + indexTab + '" data-tab-row="' + indexTabRow + '">';
                        html += '    <div class="col-md-12 el ' + DynaCore_FormConfig_Col.partClass + '" data-row="' + indexRow + '" data-col="' + indexCol + '" data-tab="' + indexTab + '" data-tab-row="' + indexTabRow + '" data-tab-col="' + indexTabCol + '"></div>';
                        html += '</div>';
                    } else {
                        html += '<div class="row el ' + DynaCore_FormConfig_Row.partClass + '" data-row="' + indexRow + '">';
                        html += '   <div class="col-md-12 el ' + DynaCore_FormConfig_Col.partClass + '" data-row="' + indexRow + '" data-col="' + indexCol + '">';
                        html += '       <div class="card shadow-sm ' + DynaCore_FormConfig_Col.partClass + '-card">';
                        html += '           <div class="card-body"></div>';
                        html += '       </div">';
                        html += '    </div>';
                        html += '</div>';
                    }

                    $(elementParent).append(html);

                    DynaCore_FormConfig.init();
                }
            });

            return false;
        },

        /**
         * Smazani objektu typu Row
         *
         * @param element
         */
        delete: function (element) {

            var data = {};
            if (parseInt($(element).data('tab-row')) >= 0) {
                data = {
                    _ch: $('#_ch').val(),
                    r: $(element).data('row'),
                    c: $(element).data('col'),
                    t: $(element).data('tab'),
                    tr: $(element).data('tab-row')
                };
            } else {
                data = {
                    _ch: $('#_ch').val(),
                    r: $(element).data('row')
                };
            }

            Lemo_Modal
                .setId('modal-container-formconfig-row-delete')
                .setTitle('Remove row')
                .setContent('<p class="text">' + translate('Do you really want to remove selected row?') + '</p>')
                .addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                    $.ajax({
                        type: 'get',
                        url: window.location.href.replace('/form-config/', '/form-config/row-delete/'),
                        data: data,
                        dataType: "json",
                        success: function () {
                            // Odebereme element
                            $(element).remove();

                            // Preindexujeme atributy radku, sloupcu a tabu
                            DynaCore_FormConfig.reindex();
                        },
                        complete: function () {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        }
    }
}